export default "__VITE_ASSET__CAeG4D_g__"